module.exports = __webpack_public_path__ + "img/gzh.80666bc4.jpg";